




























































import { Column } from '@/features/ui/table/model';
import { ArrayProp, BooleanProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { createTreeNodeTypeComparator } from '../tree-node-type/constants';
import { AttributeConfigurationType } from '@/types/iot-portal';
import { CustomerAdminRow, FormAttributeDefinition } from '@/features/app-customer/views/form/model';
import { CustomerAdminQuery_treeNodes_first_permittedUsers } from '@/features/app-customer/views/form/__generated__/CustomerAdminQuery';

interface Recipient {
  lastName: string;
  firstName: string;
  emailAddress: string;
}

@Component
export default class FormAttributeDefinitionTable extends Vue {
  @ArrayProp(() => [])
  private readonly allFormAttributeDefinitions!: FormAttributeDefinition[];

  @ArrayProp(() => [])
  private readonly disabledColumns!: string[];

  @ArrayProp(() => [])
  private readonly permittedUsers!: CustomerAdminRow[];

  @BooleanProp()
  private readonly loadingPermittedUsers!: boolean;

  private readonly comparator = createTreeNodeTypeComparator('labelPlural');

  private readonly columns: Column[] = [
    { name: 'name', field: 'attributeDefinition.configuration.name', label: 'Name', width: '15%' },
    { name: 'type', field: 'attributeDefinition.configuration.__typename', label: 'Typ', width: '5%', align: 'center' },
    {
      name: 'notificationEnabled',
      field: 'notificationEnabled',
      label: 'Benachrichtigung',
      width: '5%',
      align: 'center',
    },
    { name: 'notifyOnValues', field: 'notifyOnValues', label: 'Regel', width: '15%' },
    { name: 'notifyRecipients', field: 'notifyRecipients', label: 'Empfanger', width: '25%' },
    { name: 'notesEnabled', field: 'notesEnabled', label: 'Notiz', width: '5%', align: 'center' },
    {
      name: 'description',
      field: 'attributeDefinition.configuration.description',
      label: 'Beschreibung',
      width: '20%',
    },
    {
      name: 'treeNodeTypes',
      field: 'attributeDefinition.configuration.treeNodeTypes',
      label: 'Anwendbar auf',
    },
    { name: 'actions', label: '', width: '10%' },
  ];

  private isSelectableOrCheckbox(row: FormAttributeDefinition): boolean {
    return (
      row.attributeDefinition.configuration.__typename === AttributeConfigurationType.SelectAttributeConfiguration ||
      row.attributeDefinition.configuration.__typename === AttributeConfigurationType.CheckboxAttributeConfiguration
    );
  }

  private getNofityValues(row: FormAttributeDefinition): string[] | null {
    const selectedRow = this.allFormAttributeDefinitions.find(
      (attr) => attr.attributeDefinitionId === row.attributeDefinitionId,
    );
    return selectedRow?.notifyOnValues || null;
  }

  private availableOptions(row: FormAttributeDefinition): string[] | [] {
    const optionsList =
      row.attributeDefinition.configuration.__typename === AttributeConfigurationType.CheckboxAttributeConfiguration
        ? ['Ja', 'Nein']
        : row.attributeDefinition.configuration.__typename === AttributeConfigurationType.SelectAttributeConfiguration
        ? row.attributeDefinition.configuration?.options
        : [];
    return optionsList?.filter((o) => !row.notifyOnValues?.includes(o));
  }

  private getRecipientValue(row: FormAttributeDefinition): JSON | null {
    const selectedRow = this.allFormAttributeDefinitions.find(
      (attr) => attr.attributeDefinitionId === row.attributeDefinitionId,
    );
    return selectedRow?.notifyRecipients || null;
  }

  private isRecipient(obj: any): obj is Recipient {
    return obj && typeof obj === 'object' && 'emailAddress' in obj && 'firstName' in obj && 'lastName' in obj;
  }

  private availableRecipients(row: FormAttributeDefinition): CustomerAdminQuery_treeNodes_first_permittedUsers[] {
    const selectedRecipient = row.notifyRecipients;

    if (this.isRecipient(selectedRecipient)) {
      const filteredRecipients =
        this.permittedUsers?.filter(
          (user) =>
            user.emailAddress !== selectedRecipient.emailAddress &&
            user.firstName !== selectedRecipient.firstName &&
            user.lastName !== selectedRecipient.lastName,
        ) || [];

      return filteredRecipients;
    }

    return this.permittedUsers;
  }

  private toggleNotificationEnabled(row: FormAttributeDefinition): void {
    const updatedRow = { ...row, notificationEnabled: !row.notificationEnabled };
    this.update(row, updatedRow);
  }

  private toggleNotesEnabled(row: FormAttributeDefinition): void {
    const updatedRow = { ...row, notesEnabled: !row.notesEnabled };
    this.update(row, updatedRow);
  }

  private onOptionsChange(row: FormAttributeDefinition, value: FormAttributeDefinition['notifyOnValues']): void {
    const updatedRow = { ...row, notifyOnValues: value || [] };
    this.update(row, updatedRow);
  }

  private onRecipientsChange(row: FormAttributeDefinition, value: FormAttributeDefinition['notifyRecipients']): void {
    const updatedRow = { ...row, notifyRecipients: value || null };
    this.update(row, updatedRow);
  }

  private update(row: FormAttributeDefinition, updatedRow: FormAttributeDefinition): void {
    const updatedArray = this.allFormAttributeDefinitions?.map((item) =>
      item.attributeDefinitionId === row.attributeDefinitionId ? updatedRow : { ...item },
    );
    this.$emit('update', updatedArray);
  }
}
